import React from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  PersonAdd as PersonAddIcon,
  ContentCopy as ContentCopyIcon,
  UploadFile as UploadFileIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";

const TravelersToolbar = ({
  canEdit,
  filters,
  setFilters,
  onAddTraveler,
  onOpenCopy,
  onOpenBulkImport,
  travelers = [],
}) => {
  const handleExport = async () => {
    const XLSX = await import("xlsx");

    const rows = travelers.map((t, index) => ({
      Item: index + 1,
      DNI: t.perdni,
      Nombres: t.pernom,
      Apellidos: t.perape,
      Tramo: t.ordserdettra === "IDA" ? "SUBIDA" : "BAJADA",
      "Punto subida": t.puntosubida,
      "Punto bajada": t.puntobajada,
      Taxi: t.ordserdettaxser ? "SI" : "NO",
      Estado: t.ordserdetestpas,
      Observacion: t.ordserdetdes || "",
    }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Viajeros");
    XLSX.writeFile(wb, "viajeros_orden_servicio.xlsx");
  };

  const handleDownloadTemplate = async () => {
    const XLSX = await import("xlsx");
    const ws = XLSX.utils.json_to_sheet([
      { DNI: "43727972" },
      { DNI: "73198930" },
    ]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Plantilla");
    XLSX.writeFile(wb, "plantilla_importacion_viajeros.xlsx");
  };

  const updateFilter = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            size="small"
            label="Buscar viajero"
            placeholder="Nombre, apellido o DNI"
            value={filters.search}
            onChange={(e) => updateFilter("search", e.target.value)}
          />
        </Grid>

        <Grid item xs={6} md={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Tramo"
            value={filters.tramo}
            onChange={(e) => updateFilter("tramo", e.target.value)}
          >
            <MenuItem value="TODOS">Todos</MenuItem>
            <MenuItem value="IDA">Subida</MenuItem>
            <MenuItem value="VUELTA">Bajada</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={6} md={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Estado"
            value={filters.estado}
            onChange={(e) => updateFilter("estado", e.target.value)}
          >
            <MenuItem value="TODOS">Todos</MenuItem>
            <MenuItem value="ASIGNADO">Asignado</MenuItem>
            <MenuItem value="NO_ASIGNADO">No asignado</MenuItem>
            <MenuItem value="INVITADO">Invitado</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={6} md={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Taxi"
            value={filters.taxi}
            onChange={(e) => updateFilter("taxi", e.target.value)}
          >
            <MenuItem value="TODOS">Todos</MenuItem>
            <MenuItem value="SI">Requiere taxi</MenuItem>
            <MenuItem value="NO">Sin taxi</MenuItem>
          </TextField>
        </Grid>

        {/*<Grid item xs={12} md={3}>
          <Stack direction="row" spacing={1} justifyContent="flex-end" flexWrap="wrap">
            <Tooltip title="Descargar plantilla Excel">
              <Button variant="outlined" onClick={handleDownloadTemplate}>
                Plantilla
              </Button>
            </Tooltip>

            <Tooltip title="Exportar lista actual">
              <Button
                variant="outlined"
                startIcon={<DownloadIcon />}
                onClick={handleExport}
              >
                Exportar
              </Button>
            </Tooltip>
          </Stack>
        </Grid>*/}

        {canEdit && (
          <Grid item xs={12} md={4}>
            <Box display="flex" justifyContent="flex-end" gap={1} flexWrap="wrap">
              {/*canEdit && onOpenCopy && (
                <Button
                  variant="outlined"
                  startIcon={<ContentCopyIcon />}
                  disabled={!canEdit}
                  onClick={onOpenCopy}
                >
                  Copiar de otra orden
                </Button>
              )*/}

              {canEdit && onOpenBulkImport && (
                <Button
                  variant="outlined"
                  startIcon={<UploadFileIcon />}
                  disabled={!canEdit}
                  onClick={onOpenBulkImport}
                >
                  Importar Excel
                </Button>
              )}
              {canEdit && onAddTraveler && (
                <Button
                  variant="contained"
                  startIcon={<PersonAddIcon />}
                  disabled={!canEdit}
                  onClick={onAddTraveler}
                >
                  Agregar pasajero
                </Button>
              )}
            </Box>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default TravelersToolbar;